/* ==========================================================================
   Main Application Entry Point - Nimbokit Digital Atelier
   ========================================================================== */

import './styles/tokens.css';
import './styles/atelier.css';

import { initThemeController } from './scripts/theme.ts';
import { DigitalAtelier } from './scripts/atelier.ts';

document.addEventListener('DOMContentLoaded', () => {
  // 1. Initialize Theme Switcher (Obsidian Dark / Chalk Light)
  initThemeController('#theme-toggle-btn');

  // 2. Initialize Digital Atelier Engine
  new DigitalAtelier();
});
